import Vue from 'vue'
import i18n from '@/i18n'

const vue = new Vue({ i18n })
export default [
    {
        path: '/onboarding/dashboard',
        view: 'onboarding/dashboard/Listar',
        meta:{
            title: vue.$t("Router.Onboarding.dashboard"),
        }    
    },    
    {
        path: '/onboarding/dashboard/resultado/:idPais/:dataInicial/:dataFinal',
        view: 'onboarding/dashboard/Resultado',
        meta:{
            title: vue.$t("Router.Enquete.resultado-dashboard"),
        }    
    },    
    /*************************************************
    * Colaborador
    *************************************************/
    {
        path: '/onboarding/colaborador',
        view: 'onboarding/colaborador/Listar',
        meta:{
            title: vue.$t("Router.Onboarding.pre-cadastro"),
        }    
    },
    {
        path: '/onboarding/colaborador/adicionar',
        view: 'onboarding/colaborador/Adicionar',
        meta:{
            title: vue.$t("Router.Onboarding.pre-cadastro"),
        }    
    },
    {
        path: '/onboarding/colaborador/editar/:id',
        view: 'onboarding/colaborador/Editar',
        meta:{
            title: vue.$t("Router.Onboarding.pre-cadastro"),
        }    
    },
    /*************************************************
    * Parametrização
    *************************************************/    
    {
        path: '/onboarding/parametrizacao',
        view: 'onboarding/parametrizacao/Listar',
        meta:{
            title: vue.$t("Router.Onboarding.parametrizacao"),
        }    
    },
    /*************************************************
    * Log
    *************************************************/    
   {
    path: '/onboarding/log',
    view: 'onboarding/log/Listar',
    meta:{
        title: vue.$t("Router.Onboarding.log"),
    }    
}                                
]
